const otherEN = {
    occupations: {
        sleep: "is sleeping",
        wakeup: "is waken up",
        shower: "is showering",
        breakfast: "is having her breakfast",
        reading: "is reading",
        lessons: "is studying",
        cook: "is cooking",
        run: "is running",
        clean: "is cleaning",
        officeJob: "is working in Office"
    },
    now: "now",
    apostrophe: "'s",
    menus: {
        information: "Information",
        occupation: "Occupation",
        appearance: "Appearance",
        phone: "Phone"
    },
    appearance: {
        appearance: "Appearance",
        face: "Face",
        dress: "Dress",
        bra: "Bra",
        underpants: "Underpants"
    },
    information: {
        home: "Current Home:",
        car: "Current Car:",
        missions: "Missions:"
    },
    phone: {
        gallery: "Gallery",
        contacts: "Contacts"
    },
    missions: {
        noTasks: "Mission has no tasks",
        cor: "Overcoming. Start.",
        initCorruption_01: {
            name: "Overcoming. Start.",
            description: "Your wife has some type of mental disorder that keeps her from getting a job. " +
                "Fortunately, by chance, you got pills that can help her with this ... Do you want this?"
        },
        checkInstruction_01: {
            name: "Check pills Instructions",
            description: "You put the pills in your working table. You need to read the Instructions first."
        },
        getInfoAboutDrink_01: {
            name: "Ask about Drink",
            description: "Somehow you have to get your wife to take the pill. First you need to find out what drink she most wants to drink.",
            conditions: "relations > 13, wife is not in the bathroom or sleeping"
        },
        buyADrink_01: {
            name: "Buy Piña Colada",
            description: "Next step: buy this drink. You can go to the city and look for it in one of the supermarkets.",
            conditions: "50$ in the packet, daytime - Evening"
        },
        treatWifePill_01: {
            name: "Somehow give her the Pill",
            description: "Now it remains only to treat her with a drink (most likely it is in the refrigerator). You need to do this before eating.",
            conditions: "relations > 15, daytime - \"Start of Morning\" or \"Start of Evening\", where: Kitchen"
        },
        checkChanges_01: {
            name: "Check if there any changes",
            description: "You don't know if there will be any effect from these pills and when. Gotta constantly ask your wife how she feels.",
            conditions: "relations > 22"
        },
        askAtOfficeAboutWife_01: {
            name: "Ask about job in the Office",
            description: "Yes! I can't believe the pill really works. I need to help her and find out if we have vacancies in the office for her.",
            conditions: "where: Office"
        },
        tellWifeAboutJobOps_01: {
            name: "Tell your wife about the job opportunity",
            description: "It remains only to tell her that there's a vacancy and it's open, waiting for her to call there... I don't believe that everything is so simple."
        },
        goToInterviewAsWife_01: {
            name: "Go to interview by wife",
            description: "\"I need to go to a job interview. Hope everything goes smoothly.\"",
            conditions: "Play as wife, daytime: Morning"
        },
        goHome_01: {
            name: "Go home to congratulate her",
            description: "She got the job! Well, you should congratulate her."
        },
    },

    messages: {
        player: {
            mes01_01: "Love you!",
            mes01_02: "Love you too, bae <3",
            mes01_03: "❤️",
            mes01_04: "❤️",
            mes02_01: "Hey, babe! How are you doing?",
            mes02_02: "Fine, you?",
            mes02_03: "I'm going downtown for business meeting. Wish me good luck!",
            mes02_04: "Good luck, baby ❤️",
            mes03_01: "Look what I found in internet! New cat meme!",
            mes03_03: "lol! seems like he's very unhappy!",
            mes03_04: "I know, right? it's awesome!",
            mes04_01: "How are you doing baby?",
            mes04_02: "Fine, you?",
            mes04_03: "work is soooo boring",
            mes04_04: "maybe you send me picture to cheer me up?",
            mes04_05: "I don't do selfies, you know its better",
            mes04_06: "right, right...",
            mes05_01: "I'm hired!!!!",
            mes05_02: "Really??? I'm so happy for you! Will celebrate today?",
            mes05_03: "It's up to you",
            mes05_04: "ok"
        }
    },

    places: {
        homeMain: {
            work: "Go to work",
            goBuyPinaColada: "Go to Supermarket and duy Piña colada",
            wifeOfficeInterview: "Go to the office for an interview",
            goHome: "Go home"
        },
        homeBedroom: {
            table: "Computer table",
            bed: "Bed",
            kitchen: "Kitchen",
            bathroom: "Bathroom",
            outside: "Go outside"
        },
        homeKitchen: {
            bottle: "Piña colada",
            bedroom: "Bedroom"
        },
        homeBathroom: {
            bedroom: "Bedroom"
        },
        pillsMenu: {
            pills: "Read Pills Manual",
            back: "Back"
        },
        bedMenu: {
            sleep: "Go to sleep",
            nap: "Take a nap for a while",
            back: "Back"
        },
        wifeMenu: {
            chat: "Chat",
            howSheFeels: "Find out how she's feeling",
            makeOut: "Make out",
            bathTogether: "Suggest to take a shower together",
            getWifeInfoAboutDrink: "Try to find out about her favorite drink",
            tellWifeAboutJobInOffice: "Tell her about office work",
            checkHerAss: "Check her ass",
            wifeSexMenu: "Sexual interactions",
            back: "Back"
        },
        wifeDressUpMenu: {
            jeans: "Jeans And Pullover",
            back: "Back"
        },
        wifeSexMenu: {
            handsJob: "Handsjob",
            blowjob: "Blowjob",
            sex: "Sex",
            analSex: "Anal sex",
            back: "Back"
        },
        rentMenu: {
            rentPayment: "Take the money to the owner"
        },
        courier: {
            courierJob: "Work the shift",
            courierGoHome: "Go home",
            courierGoToOffice: "Visit the Office"
        },
        courierOffice: {
            someGuy: "Some Guy",
            colleagues: "Colleagues",
            back: "Back"
        },
        table: {
            playComputer: "Play Computer a little",
            watchPorn: "Watch porn",
            pillsMenu: "Pills",
            back: "Back"
        }
    }
};

export default otherEN;